import React from 'react';

import { Section } from './components/Section';
import { Table } from './components/Table';
import { useCustomer } from './hooks';

interface CustomerProps {}

export const Customer: React.FC<CustomerProps> = () => {
  const customer = useCustomer();

  return (
    <Section title={customer.title} searchInputProps={customer.searchInputProps}>
      <Table {...customer} />
    </Section>
  );
};
